export default __webpack_public_path__ + "./fonts/right-arrow.35d1a919.svg";